import type { DeviceModel } from '../../types/deviceModel';
import { portRow, powerPort, simpleLayout } from './layoutHelpers';
import type { MultiFaceLayout } from '../../types';

const afAtOut = {
  standards: ['802.3af', '802.3at', 'passive-24'] as const,
  perPortMaxWatts: 30,
  modeDefault: 'auto' as const,
  outputFollowsInputVoltage: true,
  poeOutOnlyWhenPoweredBy: ['dc-jack', 'dc-terminal'] as Array<'dc-jack' | 'dc-terminal'>,
};

export const rb5009uprModel: DeviceModel = {
  equipmentId: 'mikrotik-rb5009upr',
  selfDrawWatts: 15,
  shipsWithPsuId: undefined,
  powerInputs: [
    { id: 'dc-jack', kind: 'dc-jack', portNumber: 1, face: 'back', voltageMin: 24, voltageMax: 57, maxWatts: 150 },
    { id: 'dc-term', kind: 'dc-terminal', portNumber: 2, face: 'back', voltageMin: 24, voltageMax: 57, maxWatts: 150 },
    { id: 'poe-in', kind: 'poe-in', portNumber: 1, face: 'front' },
  ],
  powerSelect: 'highest-voltage',
  layout: {
    numberingSchemeId: 'mikrotik',
    multiFace: {
      defaultFace: 'front',
      faces: {
        front: simpleLayout(
          [
            ...portRow({
              count: 1,
              startNumber: 1,
              kind: 'rj45',
              labelPrefix: 'ether',
              speedsMbps: [10, 100, 1000],
              poeIn: { standards: ['802.3af', '802.3at'], voltageMin: 44, voltageMax: 57, maxWatts: 30 },
              poeOut: { ...afAtOut, standards: [...afAtOut.standards] },
              y: 18,
            }),
            ...portRow({
              count: 6,
              startNumber: 2,
              kind: 'rj45',
              labelPrefix: 'ether',
              speedsMbps: [10, 100, 1000],
              poeOut: { ...afAtOut, standards: [...afAtOut.standards] },
              startX: 12 + 24,
              y: 18,
            }),
            ...portRow({
              count: 1,
              startNumber: 8,
              kind: 'rj45',
              labelPrefix: 'ether',
              speedsMbps: [10, 100, 1000, 2500],
              poeOut: { ...afAtOut, standards: [...afAtOut.standards] },
              startX: 12 + 24 * 7,
              y: 18,
            }),
            ...portRow({
              count: 1,
              startNumber: 1,
              kind: 'sfpPlus',
              labelPrefix: 'sfpplus',
              speedsMbps: [1000, 10000],
              startX: 12 + 24 * 8,
              y: 18,
              idPrefix: 'sfpplus',
            }),
          ],
          280,
          70
        ),
        back: simpleLayout(
          [
            powerPort({ number: 1, kind: 'dc', label: 'DC jack', x: 12, y: 20 }),
            powerPort({ number: 2, kind: 'dc', label: '2-pin', x: 42, y: 20 }),
          ],
          160,
          70
        ),
      },
    } as MultiFaceLayout,
  },
};
